<template>
  <div class="printAffirmOrderBox">
    <div class="addressInformation">
      <div class="title">
        <div class="titleLeft">收货信息</div>
      </div>
      <div class="addressList">
        <div
          :class="item.checked ? 'active addressItem' : 'addressItem'"
          v-for="(item, index) in addressList"
          :key="index"
        >
          <el-checkbox
            class="checkBox"
            v-model="item.checked"
            @change="addressChecked(item)"
          ></el-checkbox>
          <div class="name">
            {{ item.receiverName }}
            <el-button
              v-if="item.checked"
              type="text"
              icon="el-icon-edit"
              style="padding: 0;position: relative;z-index: 9;"
              @click="toEditAddress(item)"
            ></el-button>
          </div>
          <div class="tel">{{ item.mobile }}</div>
          <div class="address">
            {{ item.province }}{{ item.city }}{{ item.district
            }}{{ item.areaInfo }}
          </div>
          <img
            v-if="item.checked"
            src="@/assets/addressBorder.png"
            class="addressBorder"
          />
        </div>
        <div class="addressItem addItem" @click="toDeliveryAddress">
          <div class="icon"><i class="el-icon-plus"></i></div>
          <div class="addName">新增地址</div>
        </div>
      </div>
    </div>
    <div class="orderInformation">
      <div class="title">
        <div class="titleLeft">商品信息</div>
      </div>
      <div class="informationContent">
        <div class="tableHeader">
          <div class="modelFile">商品名称</div>
          <div class="printInfo">销售规格</div>
          <div class="facilitator">积分</div>
          <div class="price">数量</div>
          <div class="printNum">总积分</div>
        </div>
        <div
          class="tableContent"
          v-for="(item, index) in updateForm"
          :key="index"
        >
          <div class="modelFile">
            <div style="display: block;">
              <div
                style="display: flex;justify-content: center;align-items: center;"
              >
                <div class="modelImg">
                  <img :src="item.goodsUrl" v-if="item.goodsUrl" />
                </div>
                <div class="flex brandBox">
                  <p class="brand" v-if="item.brand">{{ item.brand }}</p>
                  <p>{{ item.goodsName }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="printInfo">
            <div>{{ item.specName }}</div>
          </div>
          <div class="facilitator">
            <div>{{ item.specPrice }}</div>
          </div>
          <div class="price">
            <el-input-number
              v-model="item.goodsNum"
              @change="getTranslationInfo"
              :min="1"
              :max="item.totalNumber"
            ></el-input-number>
          </div>
          <div class="printNum">
            {{ item.totalPrice }}
          </div>
        </div>
      </div>
    </div>
    <!--<div class="invoiceInformation">
            <div class="title">
                <div class="titleLeft">发票信息</div>
            </div>
            <div class="invoiceContent">
                <div class="default" v-if="JSON.stringify(invoiceInfo)=='{}'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <el-button type="text" icon="el-icon-edit" @click="selectInvoice"></el-button>
                        </div>
                    </div>
                </div>
                <div class="default" v-if="invoiceInfo.activeName=='DZFP'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <span>{{ invoiceInfo.name  }}</span>
                            <span>{{ invoiceInfo.type }}</span>
                            <el-button type="text" icon="el-icon-edit" @click="selectInvoice"></el-button>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='ZZFP'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <div class="content">
                                <span>{{ invoiceInfo.name }}</span>
                                <span>{{invoiceInfo.type}}</span>
                                <el-button type="text" icon="el-icon-edit" @click="selectInvoice" style="padding: 0;"></el-button>
                            </div>
                            <div class="content"><span>发票抬头: {{invoiceInfo.title}}</span></div>
                            <div class="content" v-if="invoiceInfo.code"><span>税号: {{invoiceInfo.code}}</span></div>
                            <div class="content" v-if="invoiceInfo.bank"><span>开户银行: {{invoiceInfo.bank}}</span></div>
                            <div class="content" v-if="invoiceInfo.bankAccount"><span>银行账号: {{invoiceInfo.bankAccount}}</span></div>
                            <div class="content" v-if="invoiceInfo.address"><span>注册地址: {{invoiceInfo.address}}</span></div>
                            <div class="content" v-if="invoiceInfo.mobile"><span>注册电话: {{invoiceInfo.mobile}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='DZFP'">
                    <div class="invoiceItem">
                        <div class="name">收票邮箱：</div>
                        <div>
                            <div class="content"><span>{{invoiceInfo.email}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='ZZFP'">
                    <div class="invoiceItem">
                        <div class="name">收票地址：</div>
                        <div>
                            <div class="content"><span>收票人: {{invoiceInfo.receiverName}}</span></div>
                            <div class="content"><span>收票电话: {{invoiceInfo.mobile1}}</span></div>
                            <div class="content"><span>收票地址: {{invoiceInfo.payeeAddress}}</span></div>
                        </div>
                    </div>
                </div>
                &lt;!&ndash;<div class="remark">
                    <div class="name">备注：</div>
                    <el-input v-model="form.remark" placeholder="备注信息" style="width: 500px;"></el-input>
                </div>&ndash;&gt;
            </div>
        </div>-->
    <div class="toAffirmOrder">
      <div class="subtotal">
        <div class="name">小计：</div>
        <div class="content">{{ sumPrice }}</div>
      </div>
      <div class="freight">
        <div class="left">
          <el-checkbox v-model="printNotice"
            >请阅读后勾选
            <span @click="dialogVisible = true"
              >《宁夏工业企业数字化转型公共服务平台商售后服务协议》</span
            ></el-checkbox
          >
        </div>
        <div class="right">
          <div class="name">运费：</div>
          <div class="content">¥ 0</div>
        </div>
      </div>
      <div class="total">
        <!-- <div class="content" style="color:#E42424;font-size: 12px">系统报价仅供参考，最终报价以商家确认为准！</div> -->
      </div>
      <div class="total">
        <div class="name">合计 <span>（含运费）</span>：</div>
        <div class="content">{{ totalPrice }}</div>
      </div>
      <div class="buttonGroup">
        <el-button @click="cancelOrder">取消</el-button>
        <el-button type="primary" @click="submitOrder">确认订单</el-button>
      </div>
    </div>

    <!--新增/编辑地址-->
    <delivery-address-dialog
      ref="deliveryAddressDialogRef"
      @address="deliveryAddress"
    ></delivery-address-dialog>
    <!--发票抬头列表-->
    <invoice-title-dialog
      ref="invoiceTitleDialogRef"
      @selectInvoice="selectInvoiceValue"
    ></invoice-title-dialog>
    <!-- 协议 -->
    <el-dialog
      title="宁夏工业企业数字化转型公共服务平台商售后服务协议"
      center
      :visible.sync="dialogVisible"
      width="900px"
    >
      <el-scrollbar style="height: 600px">
        <div v-html="content" class="vHtmlMess"></div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agree()">同意服务条款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import deliveryAddressDialog from "../print/deliveryAddressDialog"
import invoiceTitleDialog from "../print/invoiceTitleDialog"
import {
  getAddressList,
  getInfoByWordNo,
  saveShopOrder,
  saveIssueInvoiceByUuid,
  calculateTransaction,
  getOrderGoodsDetail,
} from "../../utils/interface"
export default {
  name: "shopAffirmOrder",
  data() {
    return {
      uuid: "",
      goodsInfo: {},
      goodsList: [],
      updateForm: [],
      specUuid: "",
      checked: false,
      addressList: [],
      remarkValue: "",
      printNotice: false,
      invoiceInfo: {},
      printOrderUuid: "",
      facilitator: "",
      form: {},
      sumPrice: 0,
      totalPrice: 0,
      transportationPrice: 0,
      receipt: {},
      logisticsUuid: "",
      addressInfo: "",
      addressUuid: "",
      province: "",
      city: "",
      district: "",
      sumWeight: 0,
      innerVisible: false,
      fileListNew: [],
      orderBase: "",
      invoiceIssue: {},
      content: "",
      dialogVisible: false,
      activityUuid: "",
      activityType: "",
    }
  },
  mounted() {},
  components: {
    deliveryAddressDialog,
    invoiceTitleDialog,
  },
  created() {
    // 协议内容
    getInfoByWordNo({ wordNo: "3DSHFWXY" }).then((res) => {
      if (res && res.data) {
        this.content = res.data.content
      }
    })
    // 获取商品信息
    this.updateForm = JSON.parse(window.sessionStorage.getItem("updateForm"))
    if (this.updateForm.length > 0) {
      this.activityUuid = this.updateForm[0].activityUuid
      this.activityType = this.updateForm[0].activityType
      this.sumPrice = 0
      this.totalPrice = 0
      for (let i = 0; i < this.updateForm.length; i++) {
        getOrderGoodsDetail({
          uuid: this.updateForm[i].goodsUuid,
          activityUuid: this.updateForm[i].activityUuid,
        }).then((res) => {
          this.$set(this.updateForm[i], "storeId", res.data.info.storeId)
          this.$set(this.updateForm[i], "goodsName", res.data.info.name)
          this.$set(
            this.updateForm[i],
            "freightMethod",
            res.data.info.freightMethod
          )
          this.$set(
            this.updateForm[i],
            "logisticsUuid",
            res.data.info.logisticsUuid
          )
          if (res.data.info.specificationsList.length > 0) {
            for (let k = 0; k < res.data.info.specificationsList.length; k++) {
              if (
                res.data.info.specificationsList[k].uuid ==
                this.updateForm[i].goodsSpecUuid
              ) {
                this.$set(
                  this.updateForm[i],
                  "goodsUrl",
                  res.data.info.specificationsList[k].filePath
                )
                this.$set(
                  this.updateForm[i],
                  "specName",
                  res.data.info.specificationsList[k].name
                )
                this.$set(
                  this.updateForm[i],
                  "specPrice",
                  res.data.info.specificationsList[k].price
                )
                this.$set(
                  this.updateForm[i],
                  "totalNumber",
                  res.data.info.specificationsList[k].amount -
                    res.data.info.specificationsList[k].soldAmount
                )
                this.$set(
                  this.updateForm[i],
                  "totalPrice",
                  Number(
                    res.data.info.specificationsList[k].price *
                      this.updateForm[i].goodsNum
                  ).toFixed(2)
                )
                this.sumPrice =
                  Number(this.sumPrice) +
                  Number(
                    Number(res.data.info.specificationsList[k].price) *
                      Number(this.updateForm[i].goodsNum)
                  )
                this.sumPrice = Number(this.sumPrice).toFixed(2)
                this.totalPrice = Number(this.sumPrice).toFixed(2)
              }
            }
          }
        })
      }
    }
    // 获取邮寄地址
    this.getAddressList()
    this.invoiceInfo = {}
  },
  methods: {
    handleChange() {
      this.sumPrice = 0
      this.totalPrice = 0
      for (let i = 0; i < this.updateForm.length; i++) {
        this.$set(
          this.updateForm[i],
          "totalPrice",
          Number(
            this.updateForm[i].specPrice * this.updateForm[i].goodsNum
          ).toFixed(2)
        )
        this.sumPrice =
          Number(this.sumPrice) +
          Number(this.updateForm[i].specPrice * this.updateForm[i].goodsNum)
        this.sumPrice = Number(this.sumPrice).toFixed(2)
      }
      this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice)
      this.totalPrice = Number(this.totalPrice).toFixed(2)
    },
    agree() {
      this.printNotice = true
      this.dialogVisible = false
    },
    closeDlog(index) {
      this.innerVisible = index
    },
    getAddressList() {
      getAddressList().then((res) => {
        res.data.map((item) => {
          if (item.defaultVal == 1) {
            item.checked = true
            this.form.sendPostUuid = item.uuid
            this.getAddressInfo(item)
          } else {
            item.checked = false
          }
        })
        this.addressList = res.data
      })
    },
    getAddressInfo(item) {
      // 省市县
      if (item.province != "" && item.province != item.city) {
        this.province = item.province.replace("省", "")
        this.addressInfo += "," + item.province.replace("省", "")
      } else if (item.province != "" && item.province == item.city) {
        this.province = item.province.replace("市", "")
        this.addressInfo += "," + item.province.replace("市", "")
      }
      if (item.city != "" && item.province != item.city) {
        this.city = this.province + "," + item.city.replace("市", "")
        this.addressInfo += "," + item.city.replace("市", "")
      }
      if (item.district != "") {
        this.district = item.district
        this.addressInfo += "," + item.district
      }
      this.addressInfo = this.addressInfo.substring(1)
      this.addressUuid = item.uuid
      // 计算运费，后台计算
      // this.getTranslationInfo();
      this.transportationPrice = 0
    },
    // 地址选中事件
    addressChecked(val) {
      this.addressList.map((item) => {
        if (item.uuid === val.uuid) {
          item.checked = val.checked
          this.getAddressInfo(item)
        } else {
          item.checked = false
        }
      })
      this.form.sendPostUuid = val.uuid
    },
    getTranslationInfo() {
      this.transportationPrice = 0
      this.handleChange()
      /*// 循环列表查询每一条商品的运费模板
            // 是否存在当前运费
            for(let i=0;i<this.updateForm.length;i++){
                // 计算运费，每个商品都有自己的模板
                // 算出来然后加在一起就是总体的运费
                calculateTransaction({goodsUuid:this.updateForm[i].goodsUuid,
                    goodsNum:this.updateForm[i].goodsNum,addressUuid:this.addressUuid}).then((res)=>{
                        if(res.success){
                            this.$set(this.updateForm[i], "transportationPrice", res.data);
                            this.transportationPrice = Number(this.transportationPrice)+Number(res.data);
                            if(i==this.updateForm.length-1){
                                this.handleChange();
                            }
                        }
                });
            }*/
    },
    // 点击打开新增地址弹出框
    toDeliveryAddress() {
      this.$refs.deliveryAddressDialogRef.init("add")
    },
    // 新增/修改地址
    deliveryAddress(val) {
      getAddressList().then((res) => {
        res.data.map((item) => {
          if (val.uuid == item.uuid) {
            item.checked = true
          } else {
            item.checked = false
          }
        })
        this.addressList = res.data
      })
    },
    // 点击打卡编辑地址弹出框
    toEditAddress(item) {
      this.$refs.deliveryAddressDialogRef.init("edit", item)
    },
    // 点击打开选择发票
    selectInvoice() {
      // 如果有数据就回显，没有就算了
      let params = {
        uuid: "",
        orderUuid: "",
        orderNo: "",
        orderName: "",
        orderImg: "",
        orderType: "SHOP",
        issueUser: "",
        invoiceMoney: this.totalPrice,
        invoiceType: this.invoiceInfo.activeName,
        invoiceUuid: this.invoiceInfo.uuid,
        payeeUuid: this.invoiceInfo.payeeUuid,
        invoiceStatus: "EXAMINE",
      }
      this.invoiceIssue = params
      this.$refs.invoiceTitleDialogRef.init(this.invoiceIssue)
    },
    // 获取选中发票信息
    selectInvoiceValue(invoice) {
      this.form.invoiceUuid = invoice.uuid
      this.form.invoiceType = invoice.activeName
      this.form.payeeUuid = invoice.payeeUuid
      this.invoiceIssue.invoiceType = invoice.activeName
      this.invoiceIssue.invoiceUuid = invoice.uuid
      this.invoiceIssue.payeeUuid = invoice.payeeUuid
      this.invoiceIssue.issueType = invoice.activeName
      this.invoiceInfo = invoice
    },
    // 确认订单
    submitOrder() {
      this.form.totalPrice = this.totalPrice
      this.form.transportationPrice = 0
      this.form.dtoList = this.updateForm
      this.form.goodsType = this.activityType
      this.form.activityUuid = this.activityUuid
      this.form.source = "WEB"
      let addressSelected = this.addressList.filter((item) => {
        return item.checked === true
      })
      if (addressSelected.length <= 0) {
        this.$message.warning("请选择收货地址!")
      } else if (!this.printNotice) {
        this.$message.warning("请勾选购买须知!")
      } else {
        // 保存价格
        saveShopOrder(this.form).then((res) => {
          if (res.success) {
            // this.$message.success('保存成功');
            this.$router.push({
              name: "activeShopSendSuccess",
              params: { orderCode: res.data },
            })
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    cancelOrder() {
      window.location.href = "about:blank"
      window.close()
    },
  },
}
</script>

<style scoped lang="less">
div {
  box-sizing: border-box;
}

.printAffirmOrderBox {
  background: #f0f2f5;
  padding: 90px 0 100px;
  .addressInformation {
    width: 1200px;
    margin: 0 auto 20px;
    background: #fff;
    border-radius: 2px;
    .title {
      width: 100%;
      height: 56px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      .titleRight {
        display: flex;
        button {
          margin-left: 50px;
        }
      }
    }
    .addressList {
      padding: 24px 15px 0;
      display: flex;
      flex-wrap: wrap;
      .addressItem {
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #e3e3e3;
        font-size: 14px;
        .addressBorder {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        &.active {
          border: 2px dashed #fff;
        }
        &:nth-of-type(4n) {
          margin-right: 0;
        }
        .checkBox {
          position: absolute;
          right: 22px;
          top: 14px;
        }
        .name {
          color: #000;
        }
        .tel {
          color: rgba(51, 51, 51, 0.85);
          padding: 6px 0;
        }
        .address {
          color: rgba(51, 51, 51, 0.85);
          line-height: 22px;
        }
      }
      .addItem {
        text-align: center;
        cursor: pointer;
        color: #666;
        &:hover {
          border: 2px dashed #1890ff;
        }
        .icon {
          font-size: 30px;
        }
        .addName {
          font-size: 14px;
          padding-top: 5px;
        }
      }
    }
  }
  .orderInformation {
    width: 1200px;
    margin: 0 auto 20px;
    background: #fff;
    border-radius: 2px;
    .title {
      width: 100%;
      height: 56px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      .titleRight {
        display: flex;
        button {
          margin-left: 50px;
        }
      }
    }
    .informationContent {
      padding: 15px 24px;
      .tableHeader {
        padding: 0 15px;
        width: 100%;
        background: #fafafa;
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        display: flex;
      }
      .tableContent {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        font-size: 12px;
        .modelFile {
          text-align: left;
          display: flex;
          padding-right: 10px;
          .modelImg {
            width: 100px;
            height: 64px;
            position: relative;
            margin-right: 10px;
            &:hover {
              .model {
                display: block;
              }
            }
            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgba(0, 0, 0, 0.15);
            }
            .model {
              position: absolute;
              left: 0;
              top: 0;
              width: 98px;
              height: 98px;
              background: rgba(0, 0, 0, 0.3);
              text-align: center;
              line-height: 94px;
              display: none;
              i {
                color: #fff;
                cursor: pointer;
                font-size: 20px;
              }
            }
          }
          .modelInfo {
            color: #666666;
            .modelName {
              color: #000000;
              font-size: 14px;
              padding-bottom: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 195px;
            }
            .volume {
              padding: 9px 0;
            }
          }
        }
        .printInfo {
          display: flex;
          justify-content: center;
          .printInfoItem {
            display: flex;
            // justify-content: center;
            padding: 5px 0;
            .contentUi {
              text-align: left;
              li {
                width: 50%;
              }
            }
            .name {
              color: #737373;
              min-width: 80px;
              text-align: right;
            }
            .content {
              color: #000;
              ul {
                li {
                  color: #409eff;
                  cursor: pointer;
                }
              }
            }
          }
        }
        .facilitator {
          display: flex;
          justify-content: center;
          .facilitatorItem {
            display: flex;
            // justify-content: center;
            padding: 5px 0;
            .name {
              color: #737373;
              min-width: 100px;
              text-align: left;
            }
            .content {
              color: #000;
            }
          }
        }
      }
      .modelFile {
        flex: 1;
        text-align: center;
      }
      .printInfo {
        width: 150px;
        text-align: center;
      }
      .facilitator {
        width: 300px;
        text-align: center;
        display: flex;
        justify-content: center;
      }
      .price {
        width: 200px;
        text-align: center;
      }
      .printNum {
        width: 200px;
        text-align: center;
      }
    }
  }
  .invoiceInformation {
    width: 1200px;
    margin: 0 auto 20px;
    background: #fff;
    border-radius: 2px;
    .title {
      width: 100%;
      height: 56px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      .titleRight {
        display: flex;
        button {
          margin-left: 50px;
        }
      }
    }
    .invoiceContent {
      padding: 24px 35px;
      .invoiceItem {
        display: flex;
        color: rgba(51, 51, 51, 0.85);
        font-size: 14px;
        margin-bottom: 15px;
        align-items: center;
        .name {
          text-align: right;
          min-width: 80px;
          padding-right: 15px;
        }
        .content {
          span {
            padding-right: 30px;
          }
        }
      }
      .remark {
        display: flex;
        color: rgba(51, 51, 51, 0.85);
        font-size: 14px;
        margin-bottom: 15px;
        align-items: center;
        .name {
          text-align: right;
          min-width: 80px;
          padding-right: 15px;
        }
      }
      .invoiceInfo {
        .invoiceItem {
          align-items: initial;
          .content {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .toAffirmOrder {
    width: 1200px;
    margin: 0 auto 20px;
    .subtotal {
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      color: rgba(64, 64, 64, 1);
      padding-right: 15px;
      margin-bottom: 10px;
      .content {
        min-width: 100px;
        text-align: right;
      }
    }
    .freight {
      display: flex;
      justify-content: space-between;
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 1px solid #ddd;
      .right {
        display: flex;
        justify-content: flex-end;
        font-size: 14px;
        color: rgba(64, 64, 64, 1);
        padding-right: 15px;
        .content {
          min-width: 100px;
          text-align: right;
        }
      }
    }
    .total {
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      .name {
        color: rgba(64, 64, 64, 1);
        font-size: 20px;
        span {
          font-size: 14px;
        }
      }
      .content {
        color: rgba(228, 36, 36, 1);
        font-size: 20px;
        min-width: 100px;
        text-align: right;
      }
    }
    .buttonGroup {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      button {
        margin-left: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/integral/shopAffirmOrder.vue